// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".product-image-column{background:#e2b528;background:#00a5c0;width:56%}@media(max-width:899px){.product-image-column{width:100%}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
